import React, { Component } from 'react'
import PropTypes from 'prop-types'
import moment from 'moment'
import PageTitleBasic from '../../../../components/ui/typography/PageTitleBasic'
import BlankCard from '../../../../components/ui/cards/BlankCard'
import ProfileOnboardingForm from './ProfileOnboardingForm'
import accountUtils from '../../../../utils/account/accountUtils'

class PaymentScreen extends Component {
  static propTypes = {
    clearInsToken: PropTypes.func.isRequired,
    insToken: PropTypes.string,
    organizationName: PropTypes.string,
    selectPlan: PropTypes.func.isRequired,
    selectedPlan: PropTypes.any,
  }

  constructor(props) {
    super(props)

    this.getInitialDob = userType => {
      let dob = moment().subtract(13, 'years').toISOString()

      if (userType === 'admin' || userType === 'parent')
        dob  = moment().subtract(18, 'years').toISOString()

      return dob
    }
  }

  render() {
    const { clearInsToken, insToken, organizationName, selectPlan, selectedPlan } = this.props

    const plan = accountUtils.getPlanByInsTokenAndSelectedPlan(insToken, selectedPlan)
    const possibleUserTypes = accountUtils.getUserTypeOptionsForPlan(plan)
    const userType = possibleUserTypes && possibleUserTypes.length === 1 ? possibleUserTypes[0].value : undefined
    const dob = this.getInitialDob(userType)

    return (
      <div>
        <div className="container" style={{marginBottom: 80}}>
          <div className="max-1000">
            <PageTitleBasic
              delay={0.6}
              content={`Basic Info ${insToken ? '':'& Payment'} ${organizationName ? `for ${organizationName}` : ''}`}
              subContent="We'll find the most relevant news, scholarships, and connections for your goals."
              tourName='payment'
              isMobile={false}
            />
            <BlankCard notCard delay={0.85}>
              <div>
                <ProfileOnboardingForm
                  selectedPlan={selectedPlan}
                  initialValues={Object.assign(
                    {},
                    {
                      dob: null,
                      userType: undefined,
                    },
                    {
                      dob,
                      userType,
                    },
                  )}
                />
                <button
                  className="btn btn-clear mt-4"
                  style={{color: 'gray', cursor: 'pointer'}}
                  onClick={() => { insToken ? clearInsToken() : selectPlan(null)}}
                >
                  <i className="fal fa-chevron-left"/> Go Back
                </button>
              </div>
            </BlankCard>
          </div>
        </div>
      </div>
    )
  }
}

export default PaymentScreen



// WEBPACK FOOTER //
// ./src/routes/unauthenticated/Onboarding/components/PaymentScreen.js